import type { QuickSearchCategoryView } from '@/components/QuickSearch/quickSearchRoutes'
import type { QuickSearchResult } from '@/types/searchTypes'

export const MIN_QUICK_SEARCH_QUERY_LENGTH = 3
export const MIN_NUMERIC_QUICK_SEARCH_QUERY_LENGTH = 2
export const MAX_QUICK_SEARCH_QUERY_LENGTH = 100

export function isQuickSearchQueryLongEnough(query: string): boolean {
  const normalizedQuery = query.trim()
  const minimumLength = /^\d+$/.test(normalizedQuery)
    ? MIN_NUMERIC_QUICK_SEARCH_QUERY_LENGTH
    : MIN_QUICK_SEARCH_QUERY_LENGTH

  return normalizedQuery.length >= minimumLength
}

export function isValidQuickSearchQuery(query: string): boolean {
  const length = query.trim().length
  return isQuickSearchQueryLongEnough(query) && length <= MAX_QUICK_SEARCH_QUERY_LENGTH
}

export function getCategoryFromResultType(resultType: QuickSearchResult['type']): QuickSearchCategoryView {
  switch (resultType) {
    case 'subdepartment':
      return 'subdepartments'
    case 'family':
      return 'families'
    case 'supermodel':
      return 'supermodels'
    case 'model':
      return 'models'
    default:
      return 'models'
  }
}
